<template>
    <div class="drawerLayer" v-show="visible">
        <div class="mask" @click="close();"></div>
        <div class="bottomDrawer white_bg">
            <div class="generalPagePaddingH">
                <header class="header paddingV16">
                    <div class="flexLayout">
                        <div style="width: 16px;"></div>
                        <div class="flexItem alignCenter grey10 fWeight600">{{title}}</div>
                        <div style="width: 16px;">
                            <i class="icon closeIcon" @click="close()"></i>
                        </div>
                    </div>
                </header>
                <div class="body paddingT16" style="padding-bottom: 34px;">
                    <div class="paddingH16 hiddenScrollbar"
                         style="min-height: 300px; max-height: 350px; overflow: auto;">
                        <div class="couponList">

                            <div class="couponItem flexLayout" style="padding-left: 16px; color: #FF3D38;"
                                 v-for="couponItem in dataList" :key="couponItem.id">
                                <div class="alignCenter" style="width: 47px; line-height: 33px; padding-top: 15px;">
                                    <span class="f13 bold">￥</span>
                                    <span class="bold" style="font-size: 32px;"
                                          v-if="couponItem.creditType == couponTypeEnum.FULL_REDUCTION.code ||
                                        couponItem.creditType == couponTypeEnum.STAND_BY.code"
                                        >{{couponItem.creditAmount}}
                                    </span>
                                    <span class="bold" style="font-size: 32px;"
                                          v-if="couponItem.creditType === couponTypeEnum.DISCOUNT.code">
                                        {{new Number(couponItem.creditAmount * 10) + '折'}}
                                    </span>
                                </div>
                                <div class="flexItem">
                                    <div style="padding: 15px 10px 0 24px">

                                        <div class="font11r hiddenOverflow" style="line-height: 20px; height: 20px;">
                                            {{couponItem.name}}
                                        </div>

                                        <div style="line-height: 11px; font-size: 8px;">
                                            有效期:
                                            <span v-if="couponItem.startTime">
                                            {{formatDate(couponItem.startTime)}}-
                                        </span>
                                            {{couponItem.endTime ? formatDate(couponItem.endTime) : ''}}
                                        </div>
                                    </div>
                                </div>
                                <div class="alignC" style="width: 80px; padding-top: 24px;">

                                    <button class="button receiveButton" :disabled="couponItem.isReceive"
                                        @click="receiveCoupon(couponItem)">
                                        <template v-if="!couponItem.isReceive">立即领取</template>
                                        <template v-else>已领取</template>
                                    </button>
                                </div>
                            </div><!-- End couponItem -->

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import drawerPart from '../part/drawerPart';

// style
import '@/components/coupon/coupon.scss';

// data
import appConfig        from '@/appConfig';
import couponTypeEnum   from './couponTypeEnum';

import couponApi from './couponApi';

// util
import numberHelper     from '@util/numberHelper';
import appHelper from "@util/appHelper";
import consoleApi from "@comp/platformApi/consoleApi";

const config = {
    apiConfig : {
        list : {
            url : "portal/v2/coupon/getBizCouponList",
            dataPath : 'data',
            pageName : '',
            params : {},
            dataColumnMapping : {
                // userName : 'name''
            }
        },
        get : {
            url : '',
            dataColumnMapping : {
                // userName : 'name'
            }
        }
    }
};

export default {
    name: "drawerTemplate",
    extends : drawerPart,
    props : {
        title : {
            type : String,
            default : '标题'
        },
    },
    data() {
        return {
            apiConfig : config.apiConfig,

            couponTypeEnum : couponTypeEnum,
            enableDataList : true
        }
    },
    methods : {

        onLoadDataList() {
            consoleApi.log('[recieveCouponDrawer] 共' + this.dataList.length + '张优惠券可领取。');
        },
        loadDataListWithBizId(id) {
            this.apiConfig.list.params.bizId = id;
            this.reloadDataList();
        },

        receiveCoupon(dataItem) {
            couponApi.receiveCoupon(dataItem.id, () => {
                appHelper.showHint('领取成功');
                this.$set(dataItem, 'isReceive', true);
            });
        }
    },
    mounted() {
        if (appConfig.mode === 'demo')
        {
            for (let i=1; i<=8; i++)
            {
                this.dataList.push({
                    id : i,
                    couponName : '测试优惠券',
                    creditType : 1,
                    creditAmount : 1,
                    startTime : new Date().getTime() - 1000 * 7 * 3600,
                    isReceive : numberHelper.getRandomInteger(2) > 0,
                    useExpiryTime : new Date().getTime() + numberHelper.getRandomInteger(1000 * 60 * 60 * 24 * 7)
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    .closeIcon {
        width: 14px;
        height: 14px;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACFklEQVRoge2ZQU/bMBhALWCdhPgZvfnk7305k/MkdhgwumqI/vkxpE2CaTsgtaG7xCjqbEiKnWRSntRDqzp+L0nbNDZmYmIiCHBsrT0Z2sNaewIcdxqkqh+AP8CjiHzO5PYqIvIJeAR+q2rZdtwhcAts68daVc8zegZR1Qtg3fC4NcYcvDoQeAc8NAb6iIv82s8OlzvyW+DeGHPYdgNLEakCEdmPRGDPb4EnEbnqtCERWfUdISJXEfnVvhsMRgCXadWf5TfJ5BsbDkVsnHNf0qhnlG9MkC0iu3xjouQRIfl6jpuU7s0Jk0XE5FX1Ood7c+I3Rwwm3xDYO8I5txhU3rNPBLAEqsHlPV0iRifvaRMxWnnPSxEheWA88p5YROC1ClgO7RtERL4GflX/D3lPfdr8E1EfiXHLG2OMql4HTpvkF4BZeEF+/BEh+fr57uk0vojInq+AZeQzMZ6IiPzGObfw74lFJL/m70pMPvQHPBQhItVgEV3kPaOJAG66ynsGjxCRFfC0j7xnsIgU8p7eI1LKe3qLiMiv3yLvyR4Rk095szdbRB/ynuQRfcp7kkWo6qJveQ+BtYE6ot1KkbV2BvzalSfDHekYkTWCe2vtrM34A+B786uyz9UZj6qe70R8M22WmIwxpiiKU+AO+CEiZ3lV4zjnPgI/gbuiKE47DS7L8mg+n7/P5NYaa+2sLMujoT0mJsbKX2RBsPwpegpvAAAAAElFTkSuQmCC');
    }
}

</style>
